module.exports = __webpack_public_path__ + "img/9-1_02.e30c59f6.jpg";